export default "__VITE_ASSET__CNlOyo04__"